import {Injectable} from '@angular/core';
import {Antenne} from "../models/antenne";
import {Observable} from "rxjs";
import {CacheService} from "@customcoding/shared";

@Injectable({
	providedIn: 'root'
})
export class AntenneService {
	constructor(private cache: CacheService) {
	}

	getAllAntenne(): Observable<Antenne[]> {
		return this.cache.get('/api/scap/antenne');
	}
}
